/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for UCA Play icon.
 *
 * @author Senthilkumar
 */
const UCAPlay = props => (
  <SvgIcon viewBox="0 0 19 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-4-2h24v24H-4z" />
      <path
        fill="#047A9C"
        d="M2.196.169l15.863 8.28a1.75 1.75 0 0 1 0 3.102l-15.863
          8.28A1.501 1.501 0 0 1 0 18.5V1.498A1.5 1.5 0 0 1 2.196.168z"
      />
    </g>
  </SvgIcon>
);

export default UCAPlay;



// WEBPACK FOOTER //
// ./src/js/icons/UCAPlay.jsx